/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import {
  formatABN,
  formatAccountNumber,
  formatBSBNumber,
  formatedAddress,
  formatedInternationalAddress,
  formatMobile,
  formatName,
  // formatNumber,
  formatPhone,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import Spin from "../../components/Spin";
import { getVendorDetail } from "./VendorHelper";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../components/ui/card";
import DetailPhotoBody from "../../components/DetailPhotoBody";
import {
  cddCustomerTypeOptions,
  cddOptions,
  customerType,
  entityType,
  riskProfile,
} from "../../config";
import VendorSummary from "../Reports/Statements/VendorSummary";
import { Button } from "../../components/ui/button";
import { useOrganization } from "../../lib/context/OrganisationContext";

const VendorDetailsPopup = ({
  vendorId,
  // toggleShowModal,
  org,
  showView,
  setShowView,
  trustId,
  vendor,
}) => {
  const { organizationData } = useOrganization();

  const [vendorDetail, setVendorDetail] = useState(null);
  const [vendorLoading, setVendorLoading] = useState(true);
  const [showStatement, setShowStatement] = useState(null);

  const toggleStatement = () => {
    setShowStatement(!showStatement);
  };

  const normalizeVerificationData = (data = {}, verificationType = {}) => {
    if (!verificationType?.fields) return data;

    const dateKeys = verificationType.fields
      .filter((f) => f.inputType === "date")
      .map((f) => f.key);

    const normalizedData = { ...data };

    dateKeys.forEach((key) => {
      if (normalizedData[key]) {
        // eslint-disable-next-line no-self-assign
        normalizedData[key] = normalizedData[key];
      }
    });
    return normalizedData;
  };

  useEffect(() => {
    async function fetchData() {
      const vendorDetailData = await getVendorDetail(vendorId);
      vendorDetailData.kyc &&
        vendorDetailData.kyc.verifications?.length > 0 &&
        vendorDetailData.kyc.verifications?.map((item) => {
          const normalizedData = normalizeVerificationData(
            item.data,
            item.verification_document_type,
          );
          item.date_verified = item.date_verified ? item.date_verified : null;
          item.verified_by = item?.verified_by ? item?.verified_by : "";
          item.type = item?.verification_document_type_id
            ? item?.verification_document_type_id
            : "";
          item.fields = item.verification_document_type.fields?.map(
            (field) => ({
              key: field.key,
              label: field.label,
              value: normalizedData?.[field.key] ?? null,
              inputType: field.inputType || "text",
            }),
          );
          return item;
        });
      setVendorDetail(vendorDetailData);
      setVendorLoading(false);
    }
    fetchData();
  }, [vendorId, setVendorDetail]);

  return (
    <ResponsiveDrawerForm
      description={""}
      title={`${getModuleNamingBySlug(
        organizationData?.organizationData,
        "vendors",
        "Vendor",
      )} Details`}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      read={true}
    >
      <>
        {vendorLoading ? (
          <Spin full expand={true} />
        ) : (
          <div className="md:p-0 p-4">
            <DetailPhotoBody
              textValue={vendorDetail?.first_name?.charAt(0)}
              imgURL={vendorDetail?.profile_pic}
              profileName={
                vendorDetail?.business_name
                  ? vendorDetail?.business_name
                  : formatName(
                      vendorDetail?.first_name,
                      vendorDetail?.last_name,
                    )
              }
            />
            <div className="modal-content">
              <CardTitle className="text-md mb-2 flex justify-between w-full items-center">
                Personal Details{" "}
                {!org && (
                  <div>
                    <Button
                      className="p-2 h-6 mb-1.5"
                      onClick={() => {
                        toggleStatement();
                      }}
                    >
                      View Statement
                    </Button>
                  </div>
                )}
              </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                {org && (
                  <p>
                    <strong>Trust:</strong>{" "}
                    {vendorDetail?.trust
                      ? formatSubcontractorName(vendorDetail?.trust)
                      : "AML-CTF"}
                  </p>
                )}
                <p>
                  <strong>First Name:</strong>{" "}
                  {vendorDetail?.first_name ? vendorDetail?.first_name : "-"}
                </p>
                <p>
                  <strong>Last Name:</strong> {vendorDetail?.last_name}
                </p>
                <p>
                  <strong>Email Address:</strong> {vendorDetail?.email}
                </p>
                <p>
                  <strong>Phone Number:</strong>{" "}
                  {vendorDetail?.phone ? formatPhone(vendorDetail?.phone) : ""}
                </p>
                <p>
                  <strong>Mobile Number:</strong>{" "}
                  {vendorDetail?.mobile
                    ? formatMobile(vendorDetail?.mobile)
                    : "-"}
                </p>
                <p>
                  <strong>Business Name:</strong>{" "}
                  {vendorDetail?.business_name
                    ? vendorDetail?.business_name
                    : "-"}
                </p>
                <p>
                  <strong>Business Email:</strong>{" "}
                  {vendorDetail?.business_email
                    ? vendorDetail?.business_email
                    : "-"}
                </p>
                <p>
                  <strong>ABN:</strong>{" "}
                  {vendorDetail?.abn ? formatABN(vendorDetail?.abn) : "-"}
                </p>
                <p>
                  <strong>Code:</strong>{" "}
                  {vendorDetail?.code ? vendorDetail?.code : "-"}
                </p>
                <p>
                  <strong>Date of Birth:</strong>{" "}
                  {vendorDetail?.dob ? vendorDetail?.dob : "-"}
                </p>

                <p className="flex gap-1">
                  <strong className="whitespace-nowrap">Postal Address:</strong>{" "}
                  {vendorDetail?.international_address
                    ? formatedInternationalAddress(
                        vendorDetail?.full_address,
                        vendorDetail?.country?.name,
                      )
                    : formatedAddress(
                        vendorDetail?.street,
                        vendorDetail?.suburb?.name,
                        vendorDetail?.state?.name,
                        vendorDetail?.postal_code,
                      )}
                </p>
                <p className="flex gap-1">
                  <strong className="whitespace-nowrap">Street Address:</strong>{" "}
                  {vendorDetail?.shipping_international_address
                    ? formatedInternationalAddress(
                        vendorDetail?.shipping_full_address,
                        vendorDetail?.shipping_country?.name,
                      )
                    : formatedAddress(
                        vendorDetail?.shipping_street,
                        vendorDetail?.shipping_suburb?.name,
                        vendorDetail?.shipping_state?.name,
                        vendorDetail?.shipping_postal_code,
                      )}
                </p>

                <p>
                  <strong>Client Type:</strong>{" "}
                  {vendorDetail?.type
                    ? customerType?.find(
                        (item) => item.value == vendorDetail?.code,
                      )?.label
                    : "-"}
                </p>
                {vendorDetail?.type == "2" && (
                  <p>
                    <strong>Entity Type:</strong>{" "}
                    {vendorDetail?.type
                      ? entityType?.find(
                          (item) => item.value == vendorDetail?.code,
                        )?.label
                      : "-"}
                  </p>
                )}
              </div>
            </div>
            {vendorDetail?.account_name && (
              <div className="modal-content mt-4">
                <CardTitle className="text-md mb-2">
                  Bank Account Details
                </CardTitle>
                <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                  <p>
                    <strong>Bank Name:</strong>{" "}
                    {vendorDetail?.bank
                      ? vendorDetail?.bank?.abbreviation +
                        "-" +
                        vendorDetail?.bank?.name
                      : "-"}
                  </p>
                  <p>
                    <strong>Bank Account Name:</strong>{" "}
                    {vendorDetail?.account_name
                      ? vendorDetail?.account_name
                      : "-"}
                  </p>
                  <p>
                    <strong>BSB:</strong>{" "}
                    {vendorDetail?.bsb
                      ? formatBSBNumber(vendorDetail?.bsb)
                      : "-"}
                  </p>
                  <p>
                    <strong>Account Number:</strong>{" "}
                    {vendorDetail?.account_number
                      ? formatAccountNumber(vendorDetail?.account_number)
                      : "-"}
                  </p>
                  {/* <p>
                    <strong>Opening Balance:</strong>{" "}
                    {vendorDetail?.opening_balance
                      ? "$" +
                        formatNumber(Number(vendorDetail?.opening_balance))
                      : "$0.00"}
                  </p> */}
                </div>
              </div>
            )}

            {vendorDetail?.is_kyc && (
              <div className="modal-content mt-4">
                <CardTitle className="text-md mb-2">
                  Proof of ID for Vendor Verification (KYC)
                </CardTitle>
                <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                  <p>
                    <strong>CDD Customer Type:</strong>{" "}
                    {vendorDetail?.kyc?.cdd_customer_type
                      ? cddCustomerTypeOptions?.find(
                          (item) =>
                            item.value === vendorDetail?.kyc?.cdd_customer_type,
                        )?.label
                      : "-"}
                  </p>

                  <p>
                    <strong>CDD:</strong>{" "}
                    {vendorDetail?.kyc?.cdd
                      ? cddOptions?.find(
                          (item) => item.value === vendorDetail?.kyc?.cdd,
                        )?.label
                      : "-"}
                  </p>
                  <p>
                    <strong>Risk Profile:</strong>{" "}
                    {vendorDetail?.kyc?.risk
                      ? riskProfile?.find(
                          (item) => item.value === vendorDetail?.kyc?.risk,
                        )?.label
                      : "-"}
                  </p>
                </div>
                {vendorDetail?.kyc?.verifications?.map(
                  (verifyItem, verifyIndex) => (
                    <>
                      {verifyIndex !== 0 && <hr className="my-2" />}
                      <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                        <p>
                          <strong>Verification Method:</strong>{" "}
                          {verifyItem?.method_title
                            ? verifyItem?.method_title
                            : "-"}
                        </p>
                        <p>
                          <strong>Document Id:</strong>{" "}
                          {verifyItem?.verification_document_type?.label
                            ? verifyItem?.verification_document_type?.label
                            : "-"}
                        </p>
                        {/* {verifyItem?.method === 1 && (
                          <p>
                            <strong>Document Number:</strong>{" "}
                            {verifyItem?.document_number
                              ? verifyItem?.document_number
                              : "-"}
                          </p>
                        )} */}

                        {verifyItem?.method === 3 && (
                          <>
                            {verifyItem?.fields?.length > 0 &&
                              verifyItem?.fields?.map((field) => (
                                <p key={field.key}>
                                  <strong>{field.label}:</strong> {field.value}
                                </p>
                              ))}
                          </>
                        )}
                        <p>
                          <strong>Verification Date:</strong>{" "}
                          {verifyItem?.date_verified
                            ? verifyItem?.date_verified
                            : "-"}
                        </p>
                        <p>
                          <strong>Verified By:</strong>{" "}
                          {verifyItem?.verified_by
                            ? formatName(
                                verifyItem?.verified_by?.first_name,
                                verifyItem?.verified_by?.last_name,
                              )
                            : "-"}
                        </p>
                      </div>
                    </>
                  ),
                )}
              </div>
            )}

            {vendorDetail?.is_kyc && vendorDetail?.beneficiaries?.length > 0 && (
              <div className="modal-content">
                <CardTitle className="text-md mb-2 flex justify-between w-full items-center">
                  Beneficiaries
                </CardTitle>
                {vendorDetail?.beneficiaries?.map((bItem, bIndex) => (
                    <>
                      {bIndex !== 0 && <hr className="my-2" />}
                      <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                        <p>
                          <strong>Name:</strong>{" "}
                          {bItem?.name ? bItem?.name : "-"}
                        </p>
                        <p>
                          <strong>Percentage:</strong>{" "}
                          {bItem?.percentage ? `${bItem?.percentage}%` : "-"}
                        </p>
                      </div>
                    </>
                  ))}
              </div>
            )}

            {vendorDetail?.joint_accounts?.length > 0 && (
              <div className="modal-content">
                <CardTitle className="text-md mb-2 flex justify-between w-full items-center">
                  Joint Account
                </CardTitle>
                {vendorDetail?.joint_accounts?.map((jointItem, jointIndex) => (
                  <>
                    {jointIndex !== 0 && <hr className="my-2" />}
                    <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                      <p>
                        <strong>First Name:</strong>{" "}
                        {jointItem?.first_name ? jointItem?.first_name : "-"}
                      </p>
                      <p>
                        <strong>Last Name:</strong>{" "}
                        {jointItem?.last_name ? jointItem?.last_name : "-"}
                      </p>
                      <p>
                        <strong>Date of Birth:</strong>{" "}
                        {jointItem?.dob ? jointItem?.dob : "-"}
                      </p>
                      <p className="flex gap-1">
                        <strong className="whitespace-nowrap">Address:</strong>{" "}
                        {jointItem?.international_address
                          ? formatedInternationalAddress(
                              jointItem?.full_address,
                              jointItem?.country?.name,
                            )
                          : formatedAddress(
                              jointItem?.street,
                              jointItem?.suburb?.name,
                              jointItem?.state?.name,
                              jointItem?.postal_code,
                            )}
                      </p>
                      <p>
                        <strong>Bank Name:</strong>{" "}
                        {jointItem?.bank
                          ? jointItem?.bank?.abbreviation +
                            "-" +
                            jointItem?.bank?.name
                          : "-"}
                      </p>
                      <p>
                        <strong>Bank Account Name:</strong>{" "}
                        {jointItem?.account_name
                          ? jointItem?.account_name
                          : "-"}
                      </p>
                      <p>
                        <strong>BSB:</strong>{" "}
                        {jointItem?.bsb ? formatBSBNumber(jointItem?.bsb) : "-"}
                      </p>
                      <p>
                        <strong>Account Number:</strong>{" "}
                        {jointItem?.account_number
                          ? formatAccountNumber(jointItem?.account_number)
                          : "-"}
                      </p>
                    </div>
                  </>
                ))}
              </div>
            )}
          </div>
        )}
        <ResponsiveDrawerForm
          description={""}
          title={`${getModuleNamingBySlug(
            organizationData?.organizationData,
            "vendors",
            "Vendor",
          )} Statment`}
          handleOpen={() => {}}
          handleClose={() => {}}
          className={"md:w-[90vw]"}
          open={showStatement}
          buttonClassName={""}
          setOpen={setShowStatement}
          read={true}
        >
          <VendorSummary id={vendorId} trustId={trustId} vendor={vendor} />
        </ResponsiveDrawerForm>
      </>
    </ResponsiveDrawerForm>
  );
};

export default VendorDetailsPopup;
